import React from 'react';
import Divider from "@material-ui/core/Divider";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
    position: 'relative'
  },
  label: {
    position: 'relative',
    marginTop: -10,
    margin: 'auto',
    width: 100,
    background: '#F7F8FC',
    textAlign: 'center',
  }
}));

export default ({ index, block, viewOnly }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {viewOnly && <br/>}
      <Divider />
      <div className={classes.label}>{viewOnly ? '' : 'Page Break'}</div>
      {viewOnly && <br/>}
    </div>
  )
}
